/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { HcpSummaryFragmentDoc } from '../../../../core/fragments/Hcp/HCP.hook';
import { HcoSummaryFragmentDoc } from '../../../../core/fragments/Hco/HCOSummary.hook';
import {
	NotFoundErrorFragmentDoc,
	BadRequestFragmentDoc
} from '../../../../core/fragments/core.hook';
export type DcrFragment = {
	__typename?: 'DCR';
	id: any;
	networkId?: string | null;
	type: Types.DcrType;
	entityType: Types.DcrEntityType;
	entityData: string;
	note?: string | null;
	displayStatus: Types.DcrDisplayStatus;
	createdAt?: any | null;
	completedAt?: any | null;
	fieldResults?: Array<{
		__typename?: 'DCRFieldResult';
		field: string;
		group: string;
		result?: Types.DcrFieldResultStatus | null;
		previousValue?: string | null;
		requestedValue?: string | null;
		finalValue?: string | null;
	}> | null;
	resolutionNotes?: Array<{
		__typename?: 'DCRResolutionNote';
		comment: string;
	}> | null;
	attachments: Array<{
		__typename?: 'DCRAttachment';
		id: any;
		fileName: string;
		fileContentType: string;
		fileSize: number;
		viewUrl: string;
	}>;
	currentEntity?:
		| {
				__typename?: 'HCO';
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				displayName_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				affiliationSearch:
					| { __typename: 'BadRequest'; message: string; errors: Array<string> }
					| {
							__typename: 'HCOAffiliationsResults';
							results: Array<{
								__typename?: 'ParentHCO';
								vid_V: string;
								relationshipType?: {
									__typename?: 'RelationshipType';
									code: string;
								} | null;
							}>;
					  };
				licenses: Array<{ __typename?: 'License'; vid_V: string }>;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| {
				__typename?: 'HCP';
				countryId?: string | null;
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				firstNameCda_V?: string | null;
				firstNameIntl_V?: string | null;
				middleNameCda_V?: string | null;
				middleNameIntl_V?: string | null;
				lastNameCda_V?: string | null;
				lastNameIntl_V?: string | null;
				nickname_V?: string | null;
				prefixCda_V?: string | null;
				suffixCda_V?: string | null;
				allDegreeCda_V?: string | null;
				degree1Cda_V?: string | null;
				hcpTypeCda_V?: string | null;
				affiliationSearch:
					| { __typename: 'BadRequest'; message: string; errors: Array<string> }
					| {
							__typename: 'HCPAffiliationsResults';
							results: Array<{
								__typename?: 'ParentHCO';
								vid_V: string;
								isPrimaryRelationship_V?: boolean | null;
								parentHco:
									| {
											__typename?: 'HCO';
											vid_V: string;
											veevaid_V: string;
											statusCda_V?: string | null;
											statusCda_VId?: string | null;
											hcoNameCda_V?: string | null;
											displayName_V?: string | null;
											hcoNameShort_V?: string | null;
											hcoNameEnglish_V?: string | null;
											hcoNameIntl_V?: string | null;
											hcoTypeCda_V?: string | null;
											addresses: Array<{
												__typename?: 'Address';
												vid_V: string;
												primaryCda_V?: boolean | null;
												cityCda_V?: string | null;
												cityIntl_V?: string | null;
												stateCda_V?: string | null;
												countryCda_V?: string | null;
												streetAddress1Cda_V?: string | null;
												streetAddress1Intl_V?: string | null;
												postalCodeCda_V?: string | null;
												postalCodeIntl_V?: string | null;
											}>;
											hcoType?: {
												__typename?: 'HCOType';
												id: string;
												name: string;
											} | null;
									  }
									| { __typename?: 'ResourceNotFound'; message: string };
							}>;
					  };
				licenses: Array<{ __typename?: 'License'; vid_V: string }>;
				hcpType?: {
					__typename?: 'HCPType';
					id: string;
					name: string;
					count: number;
				} | null;
				hcpSpecialties: Array<{
					__typename?: 'HCPSpecialty';
					primary: boolean;
					specialty: {
						__typename?: 'Specialty';
						id: string;
						name: string;
						specialtyGroup: {
							__typename?: 'SpecialtyGroup';
							id: string;
							name: string;
						};
					};
				}>;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
		  }
		| null;
};

export const DcrFragmentDoc = gql`
	fragment DCR on DCR {
		id
		networkId
		type
		entityType
		entityData
		note
		displayStatus
		fieldResults {
			field
			group
			result
			previousValue
			requestedValue
			finalValue
		}
		resolutionNotes {
			comment
		}
		createdAt
		completedAt
		attachments {
			id
			fileName
			fileContentType
			fileSize
			viewUrl
		}
		currentEntity {
			... on HCP {
				...HCPSummary
				countryId
				affiliationSearch(
					payload: { includeInactive: false }
					paginationInput: { page: 1, pageSize: 50 }
				) {
					__typename
					... on HCPAffiliationsResults {
						results {
							vid_V
							isPrimaryRelationship_V
							parentHco {
								...HCOSummary
								...NotFoundError
							}
						}
					}
					...BadRequest
				}
				licenses {
					vid_V
				}
			}
			... on HCO {
				...HCOSummary
				affiliationSearch(
					payload: { includeInactive: false, directions: [PARENT] }
					paginationInput: { page: 1, pageSize: 50 }
				) {
					__typename
					... on HCOAffiliationsResults {
						results {
							vid_V
							relationshipType {
								code
							}
						}
					}
					...BadRequest
				}
				licenses {
					vid_V
				}
			}
		}
	}
	${HcpSummaryFragmentDoc}
	${HcoSummaryFragmentDoc}
	${NotFoundErrorFragmentDoc}
	${BadRequestFragmentDoc}
`;
